import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
const StepField = ({ control, name, }) => (_jsx(Controller, { name: name, control: control, render: ({ field: { value, }, }) => (_jsx("input", { type: "hidden", value: value })) }));
export default StepField;
//# sourceMappingURL=StepField.js.map